import React, {Component} from 'react';
import styled from 'styled-components';
import {mixins} from "../../mixins";

const Delete = styled.button`
  height: 100%;
  border: none;
  margin-left: 2px;
  background: none;
  cursor: pointer;
  width: 15px;
  ${mixins.ease()};
  position: relative;
  &:before, &:after{
    ${mixins.pseudoToBlock()};
    position: absolute;
    top: 50%;
    left: 4px;
    height: 1px;
    width: 8px;
    background-color: ${p => p.theme.cText};
  }
  &:before{
    transform: rotate(45deg);
  }
  &:after{
    transform: rotate(-45deg);
  }
  &:hover, &:focus{
    background-color: ${p => p.theme.cBorderLight};
  }
`;

class Tag extends Component {

    handleDelete = () => {
        if (typeof (this.props.onDelete) === "function") {
            this.props.onDelete()
        }
    };

    render() {
        return (
            <div className={this.props.className}>
                <span>{this.props.children}</span>
                <Delete onClick={() => this.handleDelete()}/>
            </div>
        );
    }
}

export default styled(Tag)`
  border: 1px solid ${p => p.theme.cBorderLight};
  background-color: ${p => p.theme.cBg};
  display: inline-flex;
  align-items: center;
  font-size: ${p => p.theme.sFontMicro}px;
  height: 20px;
  padding-left: 6px;
`;